import cashBookInstance from '../../cashBook/instance'

const getIsAccountingData = () => {
	return cashBookInstance.get('/cash-book/accounting-data/check')
}

export default getIsAccountingData
